import React from 'react';
import { motion } from 'framer-motion';
import { currencyDisplay } from '../helpers/commonHelper';

const StockReportTemplate = ({ onViewDetails, stockReport }) => {
  const clientData = JSON.parse(sessionStorage.getItem('clientSettings') || 'null');


  return (
    <div className="max-w-2xl mx-auto mt-12">
      <div className="space-y-4">
        {stockReport.map((item, index) => {
          const formattedStockValue = currencyDisplay(item.stockValue);
           
           

          return (
            <motion.div
              key={item.locationID}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.3 }}
              className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-lg font-QBold text-gray-800">{item.locationName}</h3>
                </div>

                <div className="text-right w-[45%]">
                  <div className="text-gray-600 font-QMedium text-sm">Stock Value</div>
                  <div className="text-sm font-QBold text-indigo-700">
                    {clientData?.mainCurrencyName} {formattedStockValue}
                  </div>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center">
                <div>
                  <div className="text-gray-600 font-QMedium text-sm">Available Stock</div>
                  <div className="text-sm font-QBold">{item.stock}</div>
                </div>
                <button
                  onClick={() => onViewDetails(item.locationID)}
                  className="px-4 py-2 bg-indigo-50 text-indigo-600 rounded-lg text-sm font-QSemiBold"
                >
                  View Details
                </button>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default StockReportTemplate;
